class SiteNotifications extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.unreadNotificationCount > 0) {
      this.externalEls.trigger.elements.forEach((element) => {
        element.dataset.ringing = true
      })
    }
  }

  setupListeners () {
    super.setupListeners()

    this.externalEls.trigger.elements.forEach((element) => {
      this.listeners.add(element, 'click', (event) => this.triggerEvent(event))
    })

    this.els.item.elements.forEach((element) => {
      this.listeners.add(element, 'click', () => {
        this.notificationsClicked = element.dataset.id
      })
    })
  }

  triggerEvent () {
    this.notificationsRead = this.dataset.ids

    this.externalEls.trigger.elements.forEach((element) => {
      element.dataset.ringing = false
    })
  }

  get unreadNotificationCount () {
    const currentNotifications = this.dataset.ids.split(',')
    const newNotifications = currentNotifications.filter(
      (id) => !this.notificationsRead?.includes(id),
    )

    return newNotifications.length
  }

  get notificationsRead () {
    return window.localStorage.getItem('site-notification:ids')
  }

  set notificationsRead (ids) {
    return window.localStorage.setItem('site-notification:ids', ids)
  }

  get notificationsClicked () {
    return window.localStorage.getItem('site-notification:clicked')
  }

  set notificationsClicked (id) {
    const ids = `${this.notificationsClicked},${id}`
    return window.localStorage.setItem('site-notification:clicked', ids)
  }
}

if (!customElements.get('site-notifications')) {
  customElements.define('site-notifications', SiteNotifications)
}
